interface BadgeRes {
  undownload_count: number
}

const useDownloadFileBadge = (orderingApiUrl: string) => {
  const { $get } = useHttpClient(orderingApiUrl as string)
  const { data } = useAuth()
  const supplierId = computed(() => data.value?.supplier?.id)

  /* --- state --- */
  const isLoading = ref(false)
  const isError = ref(false)
  const undownloadCount = ref(0)
  /* ------ */

  /* --- methods --- */
  const getDownloadFileBadge = async () => {
    if (!supplierId.value || isLoading.value) return

    isLoading.value = true
    isError.value = false
    try {
      const response = await $get<BadgeRes>(
        `/supplier_order/me/download_file_history/badge`,
        {
          headers: { 'Xo-Supplier-Id': String(supplierId.value) },
        }
      )
      undownloadCount.value = response.undownload_count
    } catch (e) {
      isError.value = true
      undownloadCount.value = 0
    } finally {
      isLoading.value = false
    }
  }
  /* ------ */

  /* --- hooks --- */
  // supplierId が取得出来るまで待機
  watch(
    supplierId,
    (val) => {
      if (val) getDownloadFileBadge()
    },
    { immediate: true }
  )
  /* ------ */

  return {
    isLoading,
    isError,
    undownloadCount,
    getDownloadFileBadge,
  }
}

export default useDownloadFileBadge
